module.exports = __webpack_public_path__ + "static/app-tour.7235f644.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/app-tour.png
// module id = 420
// module chunks = 35783957827783